// extracted by mini-css-extract-plugin
export default {"myBtn":"Button_catalogue_myBtn__lSeU7","blur":"Button_catalogue_blur__c9xps","text_no_blur":"Button_catalogue_text_no_blur__8LPCu"};